export const LOCATION_SELECTION_MESSAGE =
  'Please select a valid location from the dropdown'

type Coordinate = number | null | undefined

// Google Places writes the visible text itself, so the only proof a
// suggestion was picked is the coordinates it handed back.
const validateLocationSelection =
  (
    storedLocation: string | null | undefined,
    getCoordinates: () => [Coordinate, Coordinate],
  ) =>
  (value: string | null | undefined) => {
    if (!value || value === storedLocation) return true
    const [latitude, longitude] = getCoordinates()
    return latitude != null && longitude != null
      ? true
      : LOCATION_SELECTION_MESSAGE
  }

export default validateLocationSelection
